import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { isOurApiOrigin } from './api-url.util';
import { HmrcClientDataService } from './hmrc-client-data.service';

/**
 * Attaches the HMRC fraud-prevention `X-JL-Client-Data` header (CONTRACT §1) to
 * every request targeting our API origin, and to those requests ONLY — the
 * header carries device telemetry that must never leak to third-party origins.
 */
export const httpClientDataInterceptor: HttpInterceptorFn = (req, next) => {
  if (!isOurApiOrigin(req.url)) {
    return next(req);
  }

  const clientData = inject(HmrcClientDataService);

  return next(
    req.clone({
      setHeaders: {
        'X-JL-Client-Data': clientData.snapshot(),
      },
    }),
  );
};
